import axios from 'axios'


const service = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 1000, 
})

export const getBearerToken = key => window.$cookies.get(key);

export const setBearerToken = token => {

     

    service.headers.common['X-App'] = `sicovapp`
    service.headers.common['Authorization'] = `Bearer ${token}`
}


service.interceptors.request.use(function (config) {
     
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
})

service.interceptors.response.use(function (config) {
   return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
})

export default service